import { Component, inject, Input, OnInit } from "@angular/core";
import { ProposalHistory, ProposalHistoryDetails, ProposalHistoryItem } from "@app/core/domain/proposal-history";
import { ProposalHistoryService } from "@app/core/services/proposal-history.service";
import { IonButton, IonContent, IonIcon, IonItem, IonList, IonPopover } from "@ionic/angular/standalone";
import { TranslateService } from "@ngx-translate/core";
import { HistoryCoursesComponent } from "../history-courses/history-courses.component";
import { HistoryDetailsComponent } from "../history-details/history-details.component";

@Component({
  selector: "pa-history-info",
  templateUrl: "./history-info.component.html",
  styleUrls: ["./history-info.component.scss"],
  imports: [
    HistoryDetailsComponent,
    HistoryCoursesComponent,
    IonButton,
    IonIcon,
    IonPopover,
    IonContent,
    IonList,
    IonItem,
  ],
})
export class HistoryInfoComponent implements OnInit {
  @Input() history!: ProposalHistory;
  selectedItem: ProposalHistoryItem | undefined;
  historyDetails: ProposalHistoryDetails | undefined;
  historyItemsOpen = false;
  private readonly proposalHistoryService = inject(ProposalHistoryService);
  private readonly translate = inject(TranslateService);

  ngOnInit(): void {
    this.selectedItem = undefined;

    // If history has items, select the first one by default
    if (this.history?.items?.length) {
      this.selectItem(this.history.items[0]);
    }
  }

  selectItem(item: ProposalHistoryItem): void {
    if (item) {
      this.selectedItem = item;
      this.fetchProposalHistoryDetails(this.selectedItem);
    }
    this.historyItemsOpen = false;
  }

  getHistoryItemName(item?: ProposalHistoryItem): string {
    if (item?.statusDescription?.length) {
      return item.decisionDate?.length ? `${item.statusDescription} (${item.decisionDate})` : item.statusDescription;
    }

    return this.translate.instant("schedule.history.selectHistoryItem");
  }

  private fetchProposalHistoryDetails(item: ProposalHistoryItem) {
    this.proposalHistoryService
      .fetchProposalHistoryDetails(item.splaId, item.hsplId, item.studentNr)
      .subscribe((details) => {
        this.historyDetails = details;
      });
  }
}
